import { render, staticRenderFns } from "./StockTakeSummaryMobile.vue?vue&type=template&id=9fd61efc&scoped=true&lang=pug&"
import script from "./StockTakeSummaryMobile.vue?vue&type=script&lang=js&"
export * from "./StockTakeSummaryMobile.vue?vue&type=script&lang=js&"
import style0 from "./StockTakeSummaryMobile.vue?vue&type=style&index=0&id=9fd61efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd61efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VIcon,VProgressCircular,VRow,VSpacer})
